"use client";

import { useAtom } from "jotai";
import { FC } from "react";
import {
  DrawerStates,
  DrawerTypes,
  drawerAtom,
} from "@/app/_lib/atoms/drawer.atom";
import DetailsDrawer from "@/app/_lib/components/tax-incentives/ledger/details-drawer/details-drawer";
import CommentsDrawer from "@/app/_lib/components/tax-incentives/ledger/comments-drawer/comments-drawer";
import VendorDetailsDrawer from "@/app/_lib/components/vendors/vendor-details-drawer/vendor-details-drawer";

const Drawer: FC = () => {
  const [drawer, setDrawer] = useAtom(drawerAtom);

  return (
    <div className="drawer">
      <input
        id="app-drawer"
        type="checkbox"
        className="drawer-toggle"
        checked={drawer.state === DrawerStates.ACTIVE}
        onChange={() => {}}
      />
      <div className="drawer-side z-50">
        <label
          htmlFor="app-drawer"
          aria-label="close sidebar"
          className="drawer-overlay"
          onClick={() => setDrawer({ state: DrawerStates.DISMISSED })}
        ></label>
        <div className="p-4 w-3/4 lg:w-fit lg:max-w-1/2 min-h-full text-base-content bg-base-100">
          {(() => {
            switch (drawer.type) {
              case DrawerTypes.ENTRY_DETAILS:
                return <DetailsDrawer />;
              case DrawerTypes.ENTRY_COMMENTS:
                return <CommentsDrawer />;
              case DrawerTypes.VENDOR_DETAILS:
                return <VendorDetailsDrawer />;
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
